import {
  AerosyncEnvironment,
  type AerosyncWidget,
  initAeroSyncWidget,
  type WidgetEventSuccessType,
  type WidgetEventType,
} from 'aerosync-web-sdk'

type AeroPayErrorFn = (event: string) => void

type AeroPayEventFn = (event: WidgetEventType) => void

type AeroPayFn = () => void

type AeroPaySuccessFn = (event: WidgetEventSuccessType) => void

export const useAeroPay = (elementId: string) => {
  const {
    aeropayConsumerID: consumerId,
    datadog: { env: datadogEnvironment },
  } = useRuntimeConfig().public

  const { t } = useI18n()

  const environment: AerosyncEnvironment = (() => {
    switch (datadogEnvironment) {
      case 'prod':
        return AerosyncEnvironment.Production
      case 'staging':
        return AerosyncEnvironment.Staging
      default:
        return AerosyncEnvironment.Sandbox
    }
  })()

  const widgetControls = ref<AerosyncWidget>()

  /* callbacks */
  const onCloseCb = ref<AeroPayFn>(() => {})
  const onErrorCb = ref<AeroPayErrorFn>(() => {})
  const onEventCb = ref<AeroPayEventFn>(() => {})
  const onLoadCb = ref<AeroPayFn>(() => {})
  const onSuccessCb = ref<AeroPaySuccessFn>(() => {})

  const init = (token: string) => {
    const _widgetControls = initAeroSyncWidget({
      consumerId,
      elementId,
      environment,
      iframeTitle: t('paymentmethod.aeropay.widget.iframetitle'),
      onClose: onCloseCb.value,
      onError: onErrorCb.value,
      onEvent: onEventCb.value,
      onLoad: onLoadCb.value,
      onSuccess: onSuccessCb.value,
      theme: 'light',
      token,
      zIndex: '9999',
    })

    widgetControls.value = _widgetControls
  }

  const open = () => {
    if (!widgetControls.value) return
    widgetControls.value.launch()
  }

  return {
    init,
    onClose: (cb: AeroPayFn) => (onCloseCb.value = cb),
    onError: (cb: AeroPayErrorFn) => (onErrorCb.value = cb),
    onEvent: (cb: AeroPayEventFn) => (onEventCb.value = cb),
    onLoad: (cb: AeroPayFn) => (onLoadCb.value = cb),
    onSuccess: (cb: AeroPaySuccessFn) => (onSuccessCb.value = cb),
    open,
  }
}
